import React from 'react';
import cn from 'classname';
import './index.less';

import toString from 'lodash/toString';

import PayoutWebMoneyId from './components/payout-web-money-id';

import getCredentialClassName from './helpers/get-credential-class-name';
import formatCredential from './helpers/format-credential';

import sortKeys from '../../../../../../../../../../shared/js/sort';

function PayoutCredentials({ affiliate, payoutStatus, payoutSystem }) {
	const credentialClassName = getCredentialClassName(affiliate, payoutStatus);

	const { credentials, metadata } = affiliate.payout_settings;

	const keys = sortKeys(payoutSystem.fields || [])
		.filter((key) => !payoutSystem.fields[key].is_additional);

	const wmid = metadata && metadata.wmid;

	return (
		<div className='payout-table--body--credentials'>
			{keys.map((key, i) => (
				<div
					className='payout-table--body--credential-wrapper'
					key={i}
				>
					<div className={cn('payout-table--body--credential', credentialClassName)}>
						{formatCredential(key, toString(credentials[key]))}
					</div>
					{(i === 0) && wmid && (
						<PayoutWebMoneyId wmid={wmid} />
					)}
				</div>
			))}
		</div>
	);
}

export default PayoutCredentials;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/table/components/payout-body/components/payout-credentials/index.js